module.exports = __webpack_public_path__ + "img/inspiration_img_3.01c2441b.jpg";